<template>
  <v-row>
    <v-col>
      <h3 class="mb-2 text-text-primary">
        {{ $t('common.identity-checking.IdentityCheckingID.identityCard.title') }}
      </h3>
      <div class="text-text-secondary">
        {{ $t('common.identity-checking.IdentityCheckingID.identityCard.subTitle') }}
      </div>
    </v-col>
  </v-row>

  <v-row>
    <v-col>
      <IdentityDocumentsTypes class="mt-6" />
    </v-col>
  </v-row>
</template>

<script>
  import IdentityDocumentsTypes from './IdentityDocumentsTypes.vue'

  export default {
    name: 'IdentityDocuments',
    components: {
      IdentityDocumentsTypes,
    },
    props: {
      currentStep: {
        type: Number,
        required: true,
      },
    },
  }
</script>
